__turbopack_context__.v({
  "container": "Header-module__PJSaBa__container",
  "content": "Header-module__PJSaBa__content",
  "homeNav": "Header-module__PJSaBa__homeNav",
  "homeNavDot": "Header-module__PJSaBa__homeNavDot",
  "homeNavLink": "Header-module__PJSaBa__homeNavLink",
  "homeNavLinkActive": "Header-module__PJSaBa__homeNavLinkActive",
  "homeNavSeparator": "Header-module__PJSaBa__homeNavSeparator",
  "leftPart": "Header-module__PJSaBa__leftPart",
  "loggedMobile": "Header-module__PJSaBa__loggedMobile",
  "menuLogin": "Header-module__PJSaBa__menuLogin",
  "mobileHidden": "Header-module__PJSaBa__mobileHidden",
  "mobileLogo": "Header-module__PJSaBa__mobileLogo",
  "rightPart": "Header-module__PJSaBa__rightPart",
  "sidebarClosed": "Header-module__PJSaBa__sidebarClosed",
  "sidebarOpen": "Header-module__PJSaBa__sidebarOpen",
  "toggleBtn": "Header-module__PJSaBa__toggleBtn",
  "wText": "Header-module__PJSaBa__wText",
  "wave": "Header-module__PJSaBa__wave",
  "welcomeText": "Header-module__PJSaBa__welcomeText",
});
